const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, useDots, useShaderTransition } = window.BAO.Carousel.plugins

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return
    if (this.els.slide.elements.length <= 1) return

    this.carousel = this.setupCarousel()

    if (!this.els?.thumbnails?.exists) return
    this.thumbnailCarousel = this.setupThumbnailCarousel()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.thumbnails?.exists) {
      this.handleThumbnailTrigger = this.handleThumbnailTrigger.bind(this)

      this.els.thumbnailtrigger.elements.forEach((thumbnailtriggerEl) => {
        this.listeners.add(
          thumbnailtriggerEl,
          'click',
          this.handleThumbnailTrigger,
        )
      })
    }
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    if (!this.els.slide?.exists) return

    const plugins = [
      setInitialised(),
      useArrows({
        next: this.els?.next?.element,
        previous: this.els?.previous?.element,
      }),
      useDots(this.els?.dot?.elements),
    ]

    if (this.hasAttribute('data-shader-transition')) {
      plugins.push(useShaderTransition())
    }

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 5,
        },
        slideChanged: this.onSlideChanged,
      },
      plugins,
    )
  }

  onSlideChanged (instance) {
    if (!this.els?.thumbnails?.exists) return

    const currentSlide = instance.track.details.rel

    this.els?.thumbnail?.elements.forEach((thumbnail, index) => {
      thumbnail.setAttribute('aria-current', index === currentSlide)
    })

    if (this.thumbnailCarousel) this.thumbnailCarousel.moveToIdx(currentSlide)
  }

  setupThumbnailCarousel () {
    return new KeenSlider(
      this.els?.thumbnails?.element,
      {
        selector: this.els?.thumbnail?.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 5,
          spacing: 5,
        },
      },
      [setInitialised()],
    )
  }

  handleThumbnailTrigger (e) {
    const thumbnailTrigger = e.target.closest(
      `${this.els.thumbnailtrigger.selector}`,
    )

    const targetIndex = parseInt(thumbnailTrigger.dataset.index, 10)

    this.carousel.moveToIdx(targetIndex)
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
